import type { SiteBrand } from '~/config/branding';
import { postData } from '~/utils/service';

/** The API's allowed `requestType` values (SUPPORT_REQUEST_TYPES in mcv-api's routes/support/interfaces.py). */
export type SupportRequestType = 'ISSUE' | 'QUESTION' | 'FEEDBACK';

/** POST /support-requests body: the API's SupportRequestBody, camelCase on the wire. */
export interface SupportRequestPayload {
  brand: SiteBrand;
  subject: string;
  message: string;
  pageUrl?: string;
  /** [MCV-1866] What the user picked in the form's Type dropdown; the API words the support email by it. */
  requestType: SupportRequestType;
}

/** POST /support-requests response. */
export interface SupportRequestResponse {
  message: string;
}

export const sendSupportRequest = (data: SupportRequestPayload) =>
  postData<SupportRequestResponse>('supportRequest', { data });
